export default __webpack_public_path__ + "assets/7fad1549cd52b007d27bf8e2b557a242.png";